$ = jQuery;

/*---------------------------------------*\
Init Functions
\*---------------------------------------*/
$(document).ready(function () {
    carousels();
    moveMessage();
    safariVideo();
    galleryfn();
});

// Go step back
function goBack() {
    window.history.back();
}

function safariVideo() {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isSafari && iOS) {
        $('#hero').addClass('video-ios');
        $('.newsletter').addClass('background-ipad');
    }

}
// SCROLL UP
function scrollUp() {
    $("html, body").animate({
        scrollTop: 0
    }, 300);
}


// function move-messages
function moveMessage() {
    $('.message-wrap').prependTo('.owl-stage-outer');
}
// language selector
$(".language").click(function () {
    $(".language-toggle").fadeToggle("fast");
    $(this).toggleClass("active");
})

$(document).mouseup(function (e) {

    var container = $(".language");

    if (!container.is(e.target) && container.has(e.target).length === 0) {

        $(".language-toggle").fadeOut("fast");
        $(".language").removeClass("active");
    }
});

// array with texts to type in typewriter
// var dataText = $('.typewriter-content').data('typewriter');
//
// if ($(".typewriter-content").length) {
//   function typeWriter(text, i, fnCallback) {
//     if (i < (text.length)) {
//       document.querySelector(".typewriter-content").innerHTML = text.substring(0, i+1) +'<span aria-hidden="true"></span>';
//       setTimeout(function() {
//         typeWriter(text, i + 1, fnCallback)
//       }, 100);
//     }
//     else if (typeof fnCallback == 'function') {
//       setTimeout(fnCallback, 2500);
//     }
//   }
//   function StartTextAnimation(i) {
//     if (typeof dataText[i] == 'undefined'){
//       setTimeout(function() {
//         StartTextAnimation(0);
//       }, 20000);
//     }
//     if ( i < dataText.length ) {
//       typeWriter(dataText[i], 0, function(){
//         StartTextAnimation(i + 1);
//       });
//     }
//   }
//   StartTextAnimation(0);
// }

if ($(".typewriter-content.faster").length) {
    var dataText = $('.typewriter-content.faster').data('typewriter');
    new TypeIt('.typewriter-content', {
            speed: 50,
            startDelay: 300,
        })
        .type(dataText[0])
        .pause(1000)
        .go();
} else if ($(".typewriter-content").length) {
    var dataText = $('.typewriter-content').data('typewriter');
    new TypeIt('.typewriter-content', {
            speed: 80,
            startDelay: 300,
        })
        .type(dataText[0])
        .pause(1000)
        .delete()
        .type(dataText[1])
        .go();
}


// owl carousel
function carousels() {
    $(".carousel-testimonials").owlCarousel({

        loop: true,
        margin: 10,
        dots: false,
        nav: true,
        center: true,
        autoplay: true,
        autoplaySpeed: 800,
        navSpeed: 800,
        autoplayTimeout: 6000,
        responsive: {
            0: {
                items: 1
            }
        }
    });

    $(".carousel-detail").owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        loop: true,
        margin: 10,
        dots: true,
        nav: true,
        center: true,
        autoplay: true,
        autoplaySpeed: 800,
        navSpeed: 800,
        onInitialize: moveMessage,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            }
        }
    });
}

/*--------------------------------------
COUNTER
--------------------------------------*/
if (jQuery('#at-counters').length > 0) {
    var _tg_counters = jQuery('#at-counters');
    _tg_counters.appear(function () {
        jQuery('.number-circle .text-block > span').countTo()
    });
}

// add div after n div
if ($(window).width() < 992) {
    $("#residences>div:not(:last-child)").after("<div class='decor'></div>");
} else {
    $("#residences>div:nth-child(2n):not(:last-child)").after("<div class='decor'></div>");
}


// BURGER MENU
$('.hamburger').click(function () {
    $('.hamburger').toggleClass('is-active');


    var mobilenav = $('.mobile-nav');
    mobilenav.toggleClass('open');

    mobilenav.hasClass('open') ? $('.logo-block p').show('slow') : $('.logo-block p').hide('slow')
    mobilenav.hasClass('open') ? mobilenav.css({
        'transform': 'translateY(0%)',
        'opacity': '1'
    }) : mobilenav.css({
        'transform': 'translateY(-120%)',
        'opacity': '0'
    });
});

//initialize map
$(document).ready(function () {

    function initializeMap(mapId, latitude, longitude) {

        var location = SMap.Coords.fromWGS84(longitude, latitude);
        var marker = JAK.mel("div");
        var markerImage = JAK.mel("img", {
            src: "/static/img/svg/point.svg"
        });
        marker.appendChild(markerImage);

        var map = new SMap(JAK.gel(mapId), location, 17);
        map.addDefaultLayer(SMap.DEF_BASE).enable();

        var vrstva = new SMap.Layer.Marker();
        map.addLayer(vrstva);
        vrstva.enable();
        vrstva.addMarker(new SMap.Marker(location, null, {
            url: marker
        }));
        map.addDefaultControls();

        // disable zoom on scroll
        var mouseControl = null;
        var controls = map.getControls();

        for (var i = 0; i < controls.length; i++) {
            if (controls[i] instanceof SMap.Control.Mouse) {
                mouseControl = controls[i];
            }
        }

        mouseControl.configure(SMap.MOUSE_PAN | SMap.MOUSE_ZOOM);

        $('#' + mapId + ' > div').children().first().css('filter', 'grayscale(100%)');
    }

    Loader.async = true;
    Loader.load(null, {
        poi: true
    }, function () {

        if ($("#map").length) {

            // data attribute of flat map
            var lat_flat = $("#map").data("map-lat");
            var long_flat = $("#map").data("map-long");
            lat_flat = parseFloat(lat_flat);
            long_flat = parseFloat(long_flat);

            initializeMap("map", lat_flat, long_flat);
        }
        if ($("#map_footer").length) {

            // data attribute of footer map
            var lat_footer = $("#map_footer").data("map-lat");
            var long_footer = $("#map_footer").data("map-long");

            lat_footer = parseFloat(lat_footer);
            long_footer = parseFloat(long_footer);

            initializeMap("map_footer", lat_footer, long_footer);
        }

    });
});

//set background image for login window
$(document).ready(function () {
    var login_residence = $('.login-residence');
    var img = $(login_residence).data('login-modal-background');
    $(login_residence).css('background-image', 'url(/static/img/' + img + ')');
});

//hide message box
$(".message").click(function () {
    $(".message-wrap").fadeOut("fast");
})

// read more toggle

$(".broker-toggle").click(function () {
    $(this).prev().toggleClass('open');
    $(this).text(function (i, text) {
        return text === "Více" ? "Zavřít" : "Více";
    })
})

// control owl carousel by keyboard
var $owl = $('.carousel-detail');

$(document).on('keydown', function (event) { //attach event listener
    if (event.keyCode == 37) {
        $owl.trigger('prev.owl.carousel')
    }
    if (event.keyCode == 39) {
        $owl.trigger('next.owl.carousel')
    }
});

// play or mute video sound on click
$(".video-control").click(function () {
    if ($(this).hasClass("mute")) {
        $("video").prop('muted', false);
        $(this).removeClass("mute");
        $(this).addClass("unmute");
        $(".video-control img").attr('src', "../static/img/svg/pause.svg");
    } else {
        $("video").prop('muted', true);
        $(this).removeClass("unmute");
        $(this).addClass("mute");
        $(".video-control img").attr('src', "../static/img/svg/play.svg");
    }
})

// lightbox
$('a.gallery').featherlightGallery({
    previousIcon: '&#8249;',
    /* Code that is used as previous icon */
    nextIcon: '&#8250;',
    /* Code that is used as next icon */
    galleryFadeIn: 100,
    /* fadeIn speed when slide is loaded */
    galleryFadeOut: 300 /* fadeOut speed before slide is loaded */
});

// show max 6 gallery image

var GalleryCount = $("#gallery div").length;
var GalleryCountMargin = GalleryCount - 8;

$('#gallery div:lt(8)').show();
$('.less').hide();
var items = GalleryCount;
var shown = 8;
if (GalleryCount > 8) {
    $(".more").show().html("+ " + GalleryCountMargin + " " + $(".more").data('photos'));
    $('.more').click(function () {
        $('.less').show();
        shown = $('#gallery div:visible').length + GalleryCountMargin;
        if (shown < items) {
            $('#gallery div:lt(' + shown + ')').show(300);
        } else {
            $('#gallery div:lt(' + items + ')').show(300);
            $('.more').hide();
        }
    });
    $('.less').click(function () {
        $('#gallery div').not(':lt(8)').hide(300);
        $('.more').show();
        $('.less').hide();
    });
}

function galleryfn() {
    $('.galery').featherlightGallery({
        previousIcon: '&#8249;',
        /* Code that is used as previous icon */
        nextIcon: '&#8250;',
        /* Code that is used as next icon */
        galleryFadeIn: 100,
        /* fadeIn speed when slide is loaded */
        galleryFadeOut: 300 /* fadeOut speed before slide is loaded */
    });
}

$(".contact_toggle").on("click", function (e) {
    e.preventDefault();
    $(this).addClass("color-primary");
    $(this).parent().siblings().find("a").removeClass("color-primary");

    if ($(this).data('toggle') == 'contacts_form') {
        $("#contacts_form").show();
        $("#contacts_direct").hide();
    } else {
        $("#contacts_form").hide();
        $("#contacts_direct").show();
    }
})
